import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=04cf5a1f&scoped=true"
import script from "./Explain.vue?vue&type=script&lang=js"
export * from "./Explain.vue?vue&type=script&lang=js"
import style0 from "./Explain.vue?vue&type=style&index=0&id=04cf5a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf5a1f",
  null
  
)

export default component.exports